export default __webpack_public_path__ + "static/media/verticalGrayLine.f9aebfdc.svg";